const firebaseConfig = {
  apiKey: "AIzaSyAqG593BYbh0w4WzQvKoAAvjBK7dXaYAlg",
  authDomain: "fresh-trip-cbc63.firebaseapp.com",
  projectId: "fresh-trip-cbc63",
  storageBucket: "fresh-trip-cbc63.appspot.com",
  messagingSenderId: "622804457303",
  appId: "1:622804457303:web:35a91ad157b125546ad012"
};

export default firebaseConfig;